<template>
  <button-line
    :items="[
      {
        label: firstButtonTitle,
        route: {
          name: 'PatientRecordProgressStatus',
          params: { patientId, title: firstButtonTitle },
        },
      },
      {
        label: $ucfirst($t('journeyProgress.goalSetting')),
        route: {
          name: 'PatientRecordProgressGoalSetting',
          params: { patientId },
        },
      },
    ]"
    v-bind="$attrs"
  />
</template>

<script>
import ButtonLine from "./ButtonLine";
import { mapGetters } from "vuex";

/**
 * Component JourneyButtonLine.vue
 *
 * @module JourneyButtonLine
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/JourneyButtonLine.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "JourneyButtonLine",
  components: {
    ButtonLine,
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
    }),
    firstButtonTitle: function () {
      const v = parseInt(this.$store.getters["patientSummary/currentVersion"]);
      if (v <= 2) {
        return this.$ucfirst(
          this.$t("journeyBehaviourChangeGoals.status")
        );
      }

      return this.$ucfirst(this.$t("journeyProgress.progress"));
    },
  },
};
</script>

<style lang="scss">
</style>
